// 1-Year Chronological Bible Reading Plan Data
// This file is shared between the reading plan page and homepage
// Starts January 1, 2026

window.ReadingPlanData = (function() {
  const START_DATE = new Date(2026, 0, 1); // January 1, 2026
  
  const csvData = `Day,Reading
1,Gen 1-3
2,Gen 4-7
3,Gen 8-11
4,Job 1-5
5,Job 6-9
6,Job 10-13
7,Job 14-16
8,Job 17-20
9,Job 21-23
10,Job 24-28
11,Job 29-31
12,Job 32-34
13,Job 35-37
14,Job 38-39
15,Job 40-42
16,Gen 12-15
17,Gen 16-18
18,Gen 19-21
19,Gen 22-24
20,Gen 25-26
21,Gen 27-29
22,Gen 30-31
23,Gen 32-34
24,Gen 35-37
25,Gen 38-40
26,Gen 41-42
27,Gen 43-45
28,Gen 46-47
29,Gen 48-50
30,Exo 1-3
31,Exo 4-6
32,Exo 7-9
33,Exo 10-12
34,Exo 13-15
35,Exo 16-18
36,Exo 19-21
37,Exo 22-24
38,Exo 25-27
39,Exo 28-29
40,Exo 30-32
41,Exo 33-35
42,Exo 36-38
43,Exo 39-40
44,Lev 1-4
45,Lev 5-7
46,Lev 8-10
47,Lev 11-13
48,Lev 14-15
49,Lev 16-18
50,Lev 19-21
51,Lev 22-23
52,Lev 24-25
53,Lev 26-27
54,Num 1-2
55,Num 3-4
56,Num 5-6
57,Num 7
58,Num 8-10
59,Num 11-13
60,Num 14-15 Ps 90
61,Num 16-17
62,Num 18-20
63,Num 21-22
64,Num 23-25
65,Num 26-27
66,Num 28-30
67,Num 31-32
68,Num 33-34
69,Num 35-36
70,Deut 1-2
71,Deut 3-4
72,Deut 5-7
73,Deut 8-10
74,Deut 11-13
75,Deut 14-16
76,Deut 17-20
77,Deut 21-23
78,Deut 24-27
79,Deut 28-29
80,Deut 30-31
81,Deut 32-34 Ps 91
82,Josh 1-4
83,Josh 5-8
84,Josh 9-11
85,Josh 12-15
86,Josh 16-18
87,Josh 19-21
88,Josh 22-24
89,Jdg 1-2
90,Jdg 3-5
91,Jdg 6-7
92,Jdg 8-9
93,Jdg 10-12
94,Jdg 13-15
95,Jdg 16-18
96,Jdg 19-21
97,Ruth 1-4
98,1 Sam 1-3
99,1 Sam 4-8
100,1 Sam 9-12
101,1 Sam 13-14
102,1 Sam 15-17
103,1 Sam 18-20 Ps 11, 59
104,1 Sam 21-24
105,Ps 7, 27, 31, 34, 52
106,Ps 56, 120, 140-142
107,1 Sam 25-27
108,Ps 17, 35, 54, 63
109,1 Sam 28-31 Ps 18
110,Ps 121, 123-125, 128-130
111,2 Sam 1-4
112,Ps 6, 8-10, 14, 16, 19, 21
113,1 Ch 1-2
114,Ps 43-45, 49, 84-85, 87
115,1 Ch 3-5
116,Ps 73, 77-78
117,1 Ch 6
118,Ps 81, 88, 92-93
119,1 Ch 7-10
120,Ps 102-104
121,2 Sam 5 1 Ch 11-12
122,Ps 133
123,Ps 106-107
124,1 Ch 13-16
125,Ps 1-2, 15, 22-24, 47, 68
126,Ps 89, 96, 100-101, 105, 132
127,2 Sam 6-7 1 Ch 17
128,Ps 25, 29, 33, 36, 39
129,2 Sam 8-9 1 Ch 18
130,Ps 50, 53, 60, 75
131,2 Sam 10 1 Ch 19 Ps 20
132,Ps 65-67, 69-70
133,2 Sam 11-12 1 Ch 20
134,Ps 32, 51, 86, 122
135,2 Sam 13-15
136,Ps 3-4, 12-13, 28, 55
137,2 Sam 16-18
138,Ps 26, 40, 58, 61-62, 64
139,2 Sam 19-21
140,Ps 5, 38, 41-42
141,2 Sam 22-23 Ps 57
142,Ps 95, 97-99
143,2 Sam 24 1 Ch 21-22 Ps 30
144,Ps 108-110
145,1 Ch 23-25
146,Ps 131, 138-139, 143-145
147,1 Ch 26-29 Ps 127
148,Ps 111-118
149,1 Kgs 1-2 Ps 37, 71, 94
150,Ps 119
151,1 Kgs 3-4
152,2 Ch 1 Ps 72
153,Song 1-8
154,Prov 1-3
155,Prov 4-6
156,Prov 7-9
157,Prov 10-12
158,Prov 13-15
159,Prov 16-18
160,Prov 19-21
161,Prov 22-24
162,1 Kgs 5-6 2 Ch 2-3
163,1 Kgs 7 2 Ch 4
164,1 Kgs 8 2 Ch 5
165,2 Ch 6-7 Ps 136
166,Ps 134, 146-150
167,1 Kgs 9 2 Ch 8
168,Prov 25-26
169,Prov 27-29
170,Eccl 1-6
171,Eccl 7-12
172,1 Kgs 10-11 2 Ch 9
173,Prov 30-31
174,1 Kgs 12-14
175,2 Ch 10-12
176,1 Kgs 15 2 Ch 13-16
177,1 Kgs 16 2 Ch 17
178,1 Kgs 17-19
179,1 Kgs 20-21
180,1 Kgs 22 2 Ch 18
181,2 Ch 19-23
182,Obad 1 Ps 82-83
183,2 Kgs 1-4
184,2 Kgs 5-8
185,2 Kgs 9-11
186,2 Kgs 12-13 2 Ch 24
187,2 Kgs 14 2 Ch 25
188,Jonah 1-4
189,2 Kgs 15 2 Ch 26
190,Isa 1-4
191,Isa 5-8
192,Amos 1-5
193,Amos 6-9
194,2 Ch 27 Isa 9-12
195,Mic 1-7
196,2 Ch 28 2 Kgs 16-17
197,Isa 13-17
198,Isa 18-22
199,Isa 23-27
200,2 Kgs 18 2 Ch 29-31 Ps 48
201,Hos 1-7
202,Hos 8-14
203,Isa 28-30
204,Isa 31-34
205,Isa 35-36
206,Isa 37-39 Ps 76
207,Isa 40-43
208,Isa 44-48
209,2 Kgs 19 Ps 46, 80, 135
210,Isa 49-53
211,Isa 54-58
212,Isa 59-63
213,Isa 64-66
214,2 Kgs 20-21
215,2 Ch 32-33
216,Nah 1-3
217,2 Kgs 22-23 2 Ch 34-35
218,Zeph 1-3
219,Jer 1-3
220,Jer 4-6
221,Jer 7-9
222,Jer 10-13
223,Jer 14-17
224,Jer 18-22
225,Jer 23-25
226,Jer 26-29
227,Jer 30-31
228,Jer 32-34
229,Jer 35-37
230,Jer 38-40 Ps 74, 79
231,2 Kgs 24-25 2 Ch 36
232,Hab 1-3
233,Jer 41-45
234,Jer 46-48
235,Jer 49-50
236,Jer 51-52
237,Lam 1-2
238,Lam 3-5
239,Ezek 1-4
240,Ezek 5-8
241,Ezek 9-12
242,Ezek 13-15
243,Ezek 16-17
244,Ezek 18-20
245,Ezek 21-22
246,Ezek 23-24
247,Ezek 25-27
248,Ezek 28-30
249,Ezek 31-33
250,Ezek 34-36
251,Ezek 37-39
252,Ezek 40-42
253,Ezek 43-45
254,Ezek 46-48
255,Joel 1-3
256,Dan 1-3
257,Dan 4-6
258,Dan 7-9
259,Dan 10-12
260,Ezra 1-3
261,Ezra 4-6 Ps 137
262,Hag 1-2
263,Zec 1-4
264,Zec 5-9
265,Zec 10-14
266,Esther 1-5
267,Esther 6-10
268,Ezra 7-10
269,Neh 1-5
270,Neh 6-7
271,Neh 8-10
272,Neh 11-13 Ps 126
273,Mal 1-4
274,Luke 1 John 1
275,Matt 1 Luke 2
276,Matt 2
277,Matt 3 Mark 1 Luke 3
278,Matt 4 Luke 4-5
279,John 2-4
280,Matt 8 Mark 2
281,John 5
282,Matt 12 Mark 3 Luke 6
283,Matt 5-7
284,Matt 9 Luke 7
285,Matt 11
286,Luke 11
287,Matt 13 Luke 8
288,Mark 4-5
289,Matt 10
290,Matt 14 Mark 6 Luke 9
291,John 6
292,Matt 15 Mark 7
293,Matt 16 Mark 8
294,Matt 17 Mark 9
295,Matt 18
296,John 7-8
297,John 9-10
298,Luke 10
299,Luke 12-13
300,Luke 14-15
301,Luke 16-17
302,John 11
303,Luke 18
304,Matt 19 Mark 10
305,Matt 20-21
306,Luke 19
307,Mark 11 John 12
308,Matt 22 Mark 12
309,Matt 23 Luke 20-21
310,Mark 13
311,Matt 24
312,Matt 25
313,Matt 26 Mark 14
314,Luke 22 John 13
315,John 14-17
316,Matt 27 Mark 15
317,Luke 23 John 18-19
318,Matt 28 Mark 16
319,Luke 24 John 20-21
320,Acts 1-3
321,Acts 4-6
322,Acts 7-8
323,Acts 9-10
324,Acts 11-12
325,Acts 13-14
326,Jas 1-5
327,Acts 15-16
328,Gal 1-3
329,Gal 4-6
330,Acts 17
331,1 Th 1-5 2 Th 1-3
332,Acts 18-19
333,1 Cor 1-4
334,1 Cor 5-8
335,1 Cor 9-11
336,1 Cor 12-14
337,1 Cor 15-16
338,2 Cor 1-4
339,2 Cor 5-9
340,2 Cor 10-13
341,Rom 1-3
342,Rom 4-7
343,Rom 8-10
344,Rom 11-13
345,Rom 14-16
346,Acts 20-23
347,Acts 24-26
348,Acts 27-28
349,Col 1-4 Phm 1
350,Eph 1-6
351,Php 1-4
352,1 Tim 1-6
353,Tit 1-3
354,1 Pet 1-5
355,Heb 1-6
356,Heb 7-10
357,Heb 11-13
358,2 Tim 1-4
359,2 Pet 1-3 Jude 1
360,1 John 1-5
361,2 John 1 3 John 1
362,Rev 1-5
363,Rev 6-11
364,Rev 12-18
365,Rev 19-22
`;

  function parseCSV(csv) {
    const lines = csv.trim().split('\n');
    const data = [];
    
    for (let i = 1; i < lines.length; i++) {
      const line = lines[i];
      const firstComma = line.indexOf(',');
      if (firstComma === -1) continue;
      data.push({
        day: parseInt(line.substring(0, firstComma)),
        reading: line.substring(firstComma + 1).trim()
      });
    }
    
    return data;
  }

  function getTodayIndex() {
    const now = new Date();
    
    // Calculate day of year (0-based)
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const diff = now - startOfYear;
    const oneDay = 1000 * 60 * 60 * 24;
    const dayOfYear = Math.floor(diff / oneDay);
    
    // Return the day of year, wrapping based on actual plan length (365 days)
    // This handles day 366 in leap years by wrapping to the beginning
    return dayOfYear % 365;
  }

  /**
   * For readings with multiple passages (e.g. "Num 14-15 Ps 90"), return the first one
   * so the Bible app link opens the first passage in the sequence.
   */
  function getFirstPassage(reading) {
    if (!reading || typeof reading !== 'string') return reading || '';
    const trimmed = reading.trim();
    const first = trimmed.match(/^([\d\s]*[A-Za-z]+\s+[\d:,\s-]+?)(?=\s+[\d\s]*[A-Za-z]+(?:\s|$)|$)/);
    return first ? first[1].trim() : trimmed;
  }

  /**
   * Split a reading string into individual book segments.
   * e.g. "1 Sam 18-20 Ps 11, 59" → ["1 Sam 18-20", "Ps 11, 59"]
   */
  function splitIntoBookSegments(reading) {
    var segments = [];
    var remaining = reading.trim();

    while (remaining) {
      var match = remaining.match(/^([\d\s]*[A-Za-z]+\s+[\d:,\s-]+?)(?=\s+[\d\s]*[A-Za-z]+(?:\s|$)|$)/);
      if (!match) break;
      segments.push(match[1].trim());
      remaining = remaining.substring(match[0].length).trim();
    }

    return segments.length > 0 ? segments : [reading.trim()];
  }

  /**
   * Parse a reading into an array of individual passages, each with a label and URL.
   * Handles comma-separated chapters within a book and multi-book readings.
   * e.g. "Ps 7, 27, 31, 34, 52" → [{label:"Ps 7", url:...}, {label:"Ps 27", url:...}, ...]
   * e.g. "1 Sam 18-20 Ps 11, 59" → [{label:"1 Sam 18-20", url:...}, {label:"Ps 11", url:...}, {label:"Ps 59", url:...}]
   */
  function parseReadingIntoPassages(reading) {
    if (!reading || typeof reading !== 'string') return [];
    var trimmed = reading.trim();
    if (!trimmed) return [];

    var bookSegments = splitIntoBookSegments(trimmed);
    var passages = [];

    for (var s = 0; s < bookSegments.length; s++) {
      var segment = bookSegments[s];
      var bookMatch = segment.match(/^([\d\s]*[A-Za-z]+)\s+(.*)/);
      if (!bookMatch) {
        passages.push({ label: segment, url: getBibleUrl(segment) });
        continue;
      }

      var bookName = bookMatch[1].trim();
      var chapterPart = bookMatch[2].trim();
      var chapters = chapterPart.split(',');

      for (var c = 0; c < chapters.length; c++) {
        var ch = chapters[c].trim();
        if (!ch) continue;
        var fullPassage = bookName + ' ' + ch;
        passages.push({ label: fullPassage, url: getBibleUrl(fullPassage) });
      }
    }

    return passages;
  }

  function getBibleUrl(reading) {
    // When multiple passages (e.g. "Num 14-15 Ps 90"), use the first one for the link
    const firstPassage = getFirstPassage(reading);
    // Parse reading like "Genesis 1-2" or "John 3-4"
    const parts = firstPassage.match(/^([\d\s]*[A-Za-z]+)\s+([\d:-]+)$/);
    if (!parts) return 'https://www.bible.com';
    
    const bookName = parts[1].trim();
    const chapters = parts[2].trim();
    
    // Extract first chapter number
    const firstChapter = chapters.split('-')[0].split(':')[0];
    
    // Map book names to Bible.com abbreviations
    const bookAbbreviations = {
      'Gen': 'GEN', 'Exo': 'EXO', 'Lev': 'LEV', 'Num': 'NUM', 'Deut': 'DEU',
      'Josh': 'JOS', 'Jdg': 'JDG', 'Ruth': 'RUT', '1 Sam': '1SA', '2 Sam': '2SA',
      '1 Kgs': '1KI', '2 Kgs': '2KI', '1 Ch': '1CH', '2 Ch': '2CH',
      'Ezra': 'EZR', 'Neh': 'NEH', 'Esther': 'EST', 'Job': 'JOB',
      'Ps': 'PSA', 'Prov': 'PRO', 'Eccl': 'ECC', 'Song': 'SNG',
      'Isa': 'ISA', 'Jer': 'JER', 'Lam': 'LAM', 'Ezek': 'EZK', 'Dan': 'DAN',
      'Hos': 'HOS', 'Joel': 'JOL', 'Amos': 'AMO', 'Obad': 'OBA', 'Jonah': 'JON',
      'Mic': 'MIC', 'Nah': 'NAM', 'Hab': 'HAB', 'Zeph': 'ZEP', 'Hag': 'HAG',
      'Zec': 'ZEC', 'Mal': 'MAL',
      'Matt': 'MAT', 'Mark': 'MRK', 'Luke': 'LUK', 'John': 'JHN',
      'Acts': 'ACT', 'Rom': 'ROM', '1 Cor': '1CO', '2 Cor': '2CO',
      'Gal': 'GAL', 'Eph': 'EPH', 'Php': 'PHP', 'Col': 'COL',
      '1 Th': '1TH', '2 Th': '2TH', '1 Tim': '1TI', '2 Tim': '2TI',
      'Tit': 'TIT', 'Phm': 'PHM', 'Heb': 'HEB', 'Jas': 'JAS',
      '1 Pet': '1PE', '2 Pet': '2PE', '1 John': '1JN', '2 John': '2JN', '3 John': '3JN',
      'Jude': 'JUD', 'Rev': 'REV'
    };
    
    const abbr = bookAbbreviations[bookName];
    if (!abbr) return 'https://www.bible.com';
    
    // Use ESV version (59) - Bible.com will redirect to app if installed
    return `https://www.bible.com/bible/59/${abbr}.${firstChapter}.ESV`;
  }

  // Calculate date for each entry (starting Jan 1 of current year)
  function calculateDate(dayIndex) {
    const now = new Date();
    const startOfYear = new Date(now.getFullYear(), 0, 1);
    const date = new Date(startOfYear);
    date.setDate(date.getDate() + dayIndex);
    
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[date.getMonth()];
    const day = date.getDate();
    const year = date.getFullYear();
    
    return `${month} ${day}, ${year}`;
  }

  // Generate CSV with dates
  function generateCSV() {
    const plan = parseCSV(csvData);
    let csv = 'Date,Day,Reading\n';
    
    plan.forEach((entry, index) => {
      const dateStr = calculateDate(index);
      // Properly escape fields for CSV
      csv += `"${dateStr}",${entry.day},"${entry.reading}"\n`;
    });
    
    return csv;
  }

  // Parse and return the data
  const plan = parseCSV(csvData);

  return {
    plan: plan,
    getTodayIndex: getTodayIndex,
    getBibleUrl: getBibleUrl,
    parseReadingIntoPassages: parseReadingIntoPassages,
    calculateDate: calculateDate,
    generateCSV: generateCSV,
    START_DATE: START_DATE
  };
})();
